<template>
  <div>
    <div class="mt-4" v-for="(house, index) in houses" :key="index">
      <v-btn
        class="mb-4"
        :color="
          house.id.toString() === $route.params.houseId
            ? 'primary'
            : 'cardSurface'
        "
        large
        block
      >
        <v-icon left>mdi-home</v-icon>
        {{ house.name }}
        <v-switch
          class="ml-auto"
          :input-value="house.id.toString() === $route.params.houseId"
          inset
          color="white"
          @change="goToHouse(house)"
        ></v-switch>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ProjectBuildings",
  props: {
    houses: {},
  },

  methods: {
    goToHouse(house) {
      if (this.$route.params.houseId === house.id.toString()) {
        this.$router.push({
          name: "Project",
          params: { id: this.$route.params.id },
        });
      } else {
        this.$router.push({
          name: "ProjectHouse",
          params: { id: this.$route.params.id, houseId: house.id.toString() },
        });
      }
    },
  },
});
</script>
